<div class="tab-content">
  <div id="districtapprovals" role="tabpanel" class="tab-pane active collapse show">
    <spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
    <div class="row">
      <div class="col-md-12">
        <div class="tab" role="tabpanel">
          <ul class="nav nav-tabs" role="tablist" style="margin-top: 0px;">
            <li role="presentation" class="nav-item pointer"><a class="nav-link"
                [ngClass]="{'active': activesidetab == 'request'}" (click)="navtabclick('request')"
                name="seekingrequest" aria-selected="true">{{'dataSubs.raiserequest' | translate}}</a></li>
            <li role="presentation" class="nav-item pointer"><a class="nav-link"
                [ngClass]="{'active': activesidetab == 'approval'}" (click)="navtabclick('approval')" name="Approvals"
                aria-selected="false">{{'dataSubs.approval' | translate}}</a></li>

          </ul>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane fade active show" id="dpending" *ngIf="activesidetab == 'request'">
              <div class="d-flex justify-content-start">
                <div class="form-group mr-3">
                  <label>{{'header.assesmentyear' | translate}}<span class="text-star">*</span></label>
                  <select [(ngModel)]="requestextentionparams['assessmentyear']" class="form-control custom-selectbox"
                    (change)="yearchanged(requestextentionparams['assessmentyear'])">
                    <!-- <option value="" [disabled]="true">{{'trigManage.selectassessmentyear' | translate}}</option> -->
                    <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                  </select>
                  <div *ngIf=" userdetails && userdetails['roles'][0] == 'DISTRICT_NODAL_OFFICER'">
                    <select [(ngModel)]="requestextentionparams['assessmentyear']" class="form-control custom-selectbox"
                      (change)="yearchanged(requestextentionparams['assessmentyear'])">
                      <!-- <option value="" >{{'trigManage.selectassessmentyear' | translate}}</option> -->
                      <option *ngFor="let year of districtdropdownlist" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                </div>
  
                <div class="form-group mr-3">
                  <label>{{'dataSubs.month' | translate }}<span class="text-star">*</span></label>
                  <select [(ngModel)]="requestextentionparams['month']" (change)="selectOption($event.target.value)"
                    class="form-control custom-selectbox">
                    <option value="" [disabled]="true">{{'dataSubs.selectmonth' | translate}}</option>
                    <option *ngFor="let month of monthlist" [value]="month.key" >{{'monthmaps.' + month['value'] | translate}}</option>
                  </select>
                  <span style="color:red" [hidden]="validation[2]">{{'dataSubs.pleaseselectmonth' | translate}}</span>
                </div>
  
                <div class="form-group mr-3" style="margin-top:37px;">
                  <button class="btn btn-info btn-sm mr-2" (click)="getWindowStatus()">{{'dataSubs.SUBMIT' | translate }}</button>
                </div>

                <div *ngIf="!dontshowotherdropdowns">
                  <div class="form-group mr-3">
                    <label><span>{{'dataSubs.Start Date' | translate}}<span class="text-star">*</span></span></label>
                    <input type="text" placeholder="" [(ngModel)]="requestextentionparams['startdate']" [disabled]="true"
                      class="input-style" style="width: 100%;">
                  </div>
                  <div class="form-group mr-3">
                    <label>{{'dataSubs.End Date' | translate}}<span class="text-star">*</span></label>
                    <input type="text" placeholder="" [disabled]="true" [(ngModel)]="requestextentionparams['enddate']"
                      class="input-style" style="width: 100%;">
                  </div>
  
                  <div class="form-group mr-3">
                    <label>{{'dataSubs.Extension Date' | translate}}<span class="text-star">*</span></label>
                    <app-custom-datepicker (change)="datepickermodel($event)" class="calendar" placeholder="From"
                      [(minDate)]="minDate" [(maxDate)]="maxDate" [(calendarFormat)]="dateformat['value']"
                      [(ngModel)]="requestextentionparams['extensiondate']" ngDefaultControl></app-custom-datepicker>
                    <span style="color:red" [hidden]="validation[0]">{{'dataSubs.Please select Extension date' | translate}} </span>
                  </div>
                  <div class="form-group mr-3">
                    <label>{{'dataSubs.Reason for extension' | translate}}<span class="text-star">*</span></label>
                    <input type="text" placeholder="" [(ngModel)]="requestextentionparams['reasonforextension']"
                      class="input-style" style="width: 100%;">
                    <span style="color:red" [hidden]="validation[1]">{{'dataSubs.Please add reason for extension' | translate}}</span>
                  </div>
                  <button type="button" (click)="submit()" class="btn btn-info">{{'header.submit' | translate }}</button>
                </div>
              </div>

              
            </div>
            <div role="tabpanel" class="tab-pane fade active show" id="dpending" *ngIf="activesidetab == 'approval'">
              <div class="d-flex justify-content-start">
                  <div class="form-group  mr-3"
                    *ngIf=" userdetails && userdetails['roles'][0] != 'DISTRICT_GANGA_COMMITTEE'">
                    <label>Assessment Year</label>
                    <select [(ngModel)]="approveparams['assessmentyear']" class="form-control custom-selectbox"
                      (click)="approveyearchanged()">
                      <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                    </select>
                  </div>
                  <div class="form-group  mr-3"
                    *ngIf=" userdetails && userdetails['roles'][0] == 'DISTRICT_GANGA_COMMITTEE'">
                    <label>{{'header.assesmentyear' | translate}}<span class="text-star">*</span></label>
                    <select [(ngModel)]="requestextentionparams['assessmentyear']" class="form-control custom-selectbox"
                      (change)="onYearChange(this.requestextentionparams['assessmentyear'])">
                      <option value="">{{'trigManage.selectassessmentyear' | translate}}</option>
                      <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                    </select>
                  </div>

                  <div class="form-group  mr-3">
                    <label>{{'dataSubs.month' | translate}}<span class="text-star">*</span></label>
                    <select [(ngModel)]="approveparams['month']" (change)="selectOption($event.target.value)"
                      class="form-control custom-selectbox">
                      <option value="">{{'dataSubs.selectmonth' | translate}}</option>
                      <option *ngFor="let month of monthlist" [value]="month.key">{{'monthmaps.' + month['value'] | translate}}</option>
                    </select>
                  </div>

                  <div class="form-group mr-3" style="margin-top:37px;">
                    <button class="btn btn-info btn-sm mr-2" (click)="getraiserequesthistory()">{{'dataSubs.SUBMIT' | translate }}</button>
                  </div>

              </div>
              <br>
              <div class="table-responsive">
                <table class="table text-center table-sm mt-1">
                  <thead class="thead-light">
                    <tr>
                      <th class="positiontest" [style.top]="inverseOfTranslation" scope="col">{{'trigManage.sno' | translate}}</th>
                      <th>{{'dataSubs.Reason' | translate}}</th>
                      <th>{{'dataSubs.status' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody class="text-white" *ngIf="!shownodata">
                    <ng-container *ngFor="let table of tableData;let i=index">
                      <tr>
                        <td>{{i+1}}</td>
                        <td>{{table['reason']}}</td>
                        <td>{{table['status']}}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
  
                <div class="row" *ngIf="shownodata">
                  <div class="col-12 nodata">
                    {{'infotab.nodata' | translate}}
                  </div>
                </div>
              </div>
              
            </div>

            <!-- <div class="registration-form">
                        <form>
                            
                            <div class="form-group">
                              <label>Start Date</label>
                              <app-custom-datepicker class="calendar" placeholder="From" [(minDate)]="minDate" [(maxDate)]="maxDate"
                              [(calendarFormat)]="dateformat['value']" [(ngModel)]="fromDate"></app-custom-datepicker>
                            </div>
                            <div class="form-group">
                                <input type="password" class="form-control item" id="password" placeholder="Password">
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control item" id="email" placeholder="Email">
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control item" id="phone-number" placeholder="Phone Number">
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control item" id="birth-date" placeholder="Birth Date">
                            </div>
                            <div class="form-group">
                                <button type="button" class="btn btn-block create-account">Create Account</button>
                            </div>
                        </form>
                        
                    </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
